import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  private cachedData: any;
  data;
  constructor() { }
  run() {
    console.log("featureService");
  }
  setdata(data) {
    this.data=data;
  }
  getdata(){
    return this.data
  }

    retrieveData(): any {
      return this.cachedData;
    }
  
    storeData(data: any): void {
      this.cachedData = data;
    }
  
    clearCache(): void {
      this.cachedData = null;
    }
}
